import {
  formatAssetAmount,
  getAssetPrecision,
  getFiatSymbol,
} from '@altify/utils';
import { Language } from 'store/slices/language-slice';
import appHelpers from '../utils/app-urls';
import { ActiveProductDtoTypeEnum } from 'services/generated';

// TODO :: Below and is CryptoCurrency checks need to be change when product.type is passed through for pending withdrawals
const tradableFiatCurrencies = [
  'R',
  'GB',
  'ZAR',
  'GBP',
  '£',
  'USD',
  '$',
  'EUR',
  '€',
];

export const isCryptoCurrency = (productCode: any) => {
  return !tradableFiatCurrencies.includes(productCode);
};
export const commodityProductCodes = ['PAXG'];

export const formatCurrency = (
  amount: number | string | undefined | null,
  code: string | undefined | null,
) => {
  const numeric = amount == null || amount === '' ? null : Number(amount);

  if (numeric == null || !Number.isFinite(numeric)) {
    return formatAssetAmount(null, code ?? null, { showSpacer: true });
  }

  const precision = getAssetPrecision(code ?? null);

  // Fiat below a cent. formatAssetAmount only widens to 6 decimals at <= 0.001,
  // so 0.005 would render as 0.01. Render this band here instead. The < 0.01
  // threshold matches the mobile app (its utils/currencies.ts), so a real
  // balance can't read as 0.00 on web and 0.005000 on mobile.
  if (precision === 2 && numeric < 0.01 && numeric >= 0.000001) {
    return `${getFiatSymbol(code ?? null)}${numeric.toFixed(6)}`;
  }

  return formatAssetAmount(numeric, code ?? null, { showSpacer: true });
};

const messages = {
  en: {
    crypto: 'Crypto',
    stablecoin: 'Stablecoin',
    currency: 'Currency',
    reserved: 'Reserved',
    cryptoBundle: 'Crypto Bundle',
    commodity: 'Commodity',
    privateCredit: 'Private Credit',
    stocks: 'Stock',
    tokenizedStocks: 'Tokenised Stock',
  },
};

export const getCurrencyTypeLabel = (
  productCode: string,
  type: ActiveProductDtoTypeEnum,
  language?: Language,
) => {
  const commonMessages = messages[(language as Language) || 'en'];

  // TODO: enable when we have added the commodities tab in the app.
  if (['PAXG'].includes(productCode as string)) {
    return commonMessages.commodity;
  }

  switch (type) {
    case ActiveProductDtoTypeEnum.Fiat:
      return commonMessages.currency;
    case ActiveProductDtoTypeEnum.Crypto:
      if (productCode?.toLowerCase().includes('rvx')) {
        return commonMessages.cryptoBundle;
      }
      return commonMessages.crypto;
    case ActiveProductDtoTypeEnum.Bundle:
      return commonMessages.cryptoBundle;
    case ActiveProductDtoTypeEnum.Stablecoin:
      return commonMessages.stablecoin;
    case ActiveProductDtoTypeEnum.Locked:
      return commonMessages.reserved;
    case ActiveProductDtoTypeEnum.PrivateCredit:
      return commonMessages.privateCredit;
    case ActiveProductDtoTypeEnum.Stock:
      return commonMessages.tokenizedStocks;
    default:
      return type;
  }
};
